import React, { useCallback } from 'react';
import { Grid, Slider, Typography } from '@material-ui/core';

import useId from '../../../../hooks/useId';
import { SliderStyles } from './styles';

type Props = {
  title: React.ReactNode;
  value: number;
  onChange: (value: number) => void;
  max?: number;
  step?: number;
};

const SliderComponent = ({ title, value, onChange, max = 100, step = 1 }: Props) => {
  const classes = SliderStyles();
  const id = useId();

  const handleChange = useCallback(
    (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
      onChange(newValue as number);
    },
    [onChange],
  );

  return (
    <Grid container>
      <Typography id={id} gutterBottom className={classes.title}>
        {title}
      </Typography>
      <Grid container>
        <Slider
          value={value}
          onChange={handleChange}
          aria-labelledby={id}
          max={max}
          step={step}
          valueLabelDisplay="auto"
          classes={{
            root: classes.root,
            rail: classes.rail,
            thumb: classes.thumb,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default SliderComponent;
